import { Link } from "react-router-dom";
export const Footer = () => {
  return <footer className="text-white bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 bg-transparent">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Tentang IDN</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="hover:text-gray-300">Tentang Kami</Link></li>
              <li><Link to="/career" className="hover:text-gray-300">Karir</Link></li>
              <li><Link to="/contact" className="hover:text-gray-300">Kontak</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Produk</h3>
            <ul className="space-y-2">
              <li><Link to="/kasflow" className="hover:text-gray-300">Kasflow</Link></li>
              <li><Link to="/pordi" className="hover:text-gray-300">Pordi</Link></li>
              <li><Link to="/pembayaran" className="hover:text-gray-300">Pembayaran</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Bantuan</h3>
            <ul className="space-y-2">
              <li><Link to="/faq" className="hover:text-gray-300">FAQ</Link></li>
              <li><Link to="/support" className="hover:text-gray-300">Pusat Bantuan</Link></li>
              <li><Link to="/tutorial" className="hover:text-gray-300">Tutorial</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/terms" className="hover:text-gray-300">Syarat & Ketentuan</Link></li>
              <li><Link to="/privacy" className="hover:text-gray-300">Kebijakan Privasi</Link></li>
              <li><Link to="/security" className="hover:text-gray-300">Keamanan</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p>&copy; {new Date().getFullYear()} Jaringan IDN. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};